import httpResource from "@/components/infrastructures/functions/http/httpResource";

export default class AccountRegisterService {

    public static async registerAgencyAdmin(data: any) {
        return (await httpResource.post('/account/register-agency-admin', data));
    }
}